module.exports = __webpack_public_path__ + "img/factor_b.ce28d1e4.svg";